function getAuthToken(): string | null {
  const key = Object.keys(localStorage).find(k => k.startsWith('__convexAuthJWT'))
  return key ? localStorage.getItem(key) : null
}

async function stripePost(path: string, body?: Record<string, unknown>): Promise<{ url?: string; error?: string }> {
  const token = getAuthToken()
  if (!token) throw new Error('Not authenticated')

  const res = await fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: body ? JSON.stringify(body) : undefined,
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.error || 'Request failed')
  return data
}

export async function createPortalSession(): Promise<string> {
  const data = await stripePost('/api/stripe/portal')
  return data.url!
}

export async function createCheckoutSession(args: {
  planId: string
  cancelPath?: string
  trial?: boolean
  origin?: string
  clientIp?: string
}): Promise<string> {
  const data = await stripePost('/api/stripe/checkout', args)
  return data.url!
}
